<template>
  <AmountStep
    v-if="state.matches('refundFlow.amountStep')"
    :is-partial-refund-allowed="refundInfo.isPartialRefundAllowed"
    :max-refund-price="refundInfo.maxRefundPrice"
    :partial-refund-amount="partialRefundPrice?.amount"
    :send
    @done="handleRefundDone"
    @save-partial-refund-amount="
      (amount) => (partialRefundPrice.amount = amount)
    "
  >
    <template #before-form>
      <RefundWarning :refundInfo />
    </template>
    <NextTaskCheckbox
      v-if="hasNextTask && FF_ENABLE_CUSTOMER_CARE_REQUEST_NAVIGATION"
      v-model="isNextTaskChecked"
    />
  </AmountStep>

  <PartialRefundStep
    v-if="state.matches('refundFlow.partialRefundStep')"
    :price="partialRefundPrice"
    :send
    @done="handleRefundDone"
  >
    <template #before-form>
      <RefundWarning :refundInfo />
    </template>
    <NextTaskCheckbox
      v-if="hasNextTask && FF_ENABLE_CUSTOMER_CARE_REQUEST_NAVIGATION"
      v-model="isNextTaskChecked"
    />
  </PartialRefundStep>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'
import { computed, ref } from 'vue'

import type { MonetaryAmount } from '@backmarket/http-api'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import type { OrderlineOpenTask } from '~/api/seller-after-sales/types'
import { fetchAndGoToNextTask } from '~/scopes/customer-care/components/request.helpers'

import type {
  MachineSend,
  MachineState,
  RefundInfo,
} from '../../ActionBar.machine.type'
import NextTaskCheckbox from '../NextTaskCheckbox/NextTaskCheckbox.vue'

import AmountStep from './AmountStep/AmountStep.vue'
import PartialRefundStep from './PartialRefundStep/PartialRefundStep.vue'
import RefundWarning from './components/RefundWarning/RefundWarning.vue'

const emit = defineEmits(['done'])

const props = defineProps<{
  mostUrgentTask?: OrderlineOpenTask
  refundInfo: RefundInfo
  send: MachineSend
  state: MachineState
}>()

const partialRefundPrice = ref<MonetaryAmount>({
  amount: '',
  currency: props.refundInfo.maxRefundPrice.currency,
})

const hasNextTask = computed(() => Boolean(props.mostUrgentTask))
const isNextTaskChecked = ref(hasNextTask.value)
const { openErrorToast } = useTheToast()
const { FF_ENABLE_CUSTOMER_CARE_REQUEST_NAVIGATION } = useRuntimeConfig().public

function handleRefundDone() {
  if (isNextTaskChecked.value && FF_ENABLE_CUSTOMER_CARE_REQUEST_NAVIGATION)
    fetchAndGoToNextTask(props.mostUrgentTask?.id).catch(() => {
      openErrorToast()
    })
  emit('done')
}
</script>
